import React from 'react';
import './Spinner.css'

const Spinner = (props) => {
    return (
        <div className="loader">
           
        </div>
    )
}

export default Spinner;